/** Outward delivery service name. Never a courier-provider brand (`INV-08`). */
export const BEATQ_DELIVERY_BRAND = 'BeatQ Del' as const;

export type BeatqDeliveryBrand = typeof BEATQ_DELIVERY_BRAND;

export function beatqDelIdentity(firstName?: string | null): string {
  const name = firstName?.trim();
  return name ? `${BEATQ_DELIVERY_BRAND} · ${name}` : BEATQ_DELIVERY_BRAND;
}
